import React from 'react';

interface EmployeeInputProps {
  parentID: string;
  onAddEmployee: (parentID: string, id: string, name: string) => void;
  onClose: () => void;
}

export const EmployeeInput: React.FC<EmployeeInputProps> = ({ parentID, onAddEmployee, onClose }) => {
  const [id, setId] = React.useState('');
  const [name, setName] = React.useState('');

  const handleAdd = () => {
    if (!id || !name) {
      alert("Please provide both Employee ID and Employee Name.");
      return;
    }
    onAddEmployee(parentID, id, name);
    setId(''); // Clear input after adding
    setName('');
    onClose(); // Close the input box
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '1em' }}>
      <input
        type="text"
        placeholder="Employee ID"
        value={id}
        onChange={(e) => setId(e.target.value)}
        style={{ marginRight: '0.5em' }}
      />
      <input
        type="text"
        placeholder="Employee Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={{ marginRight: '0.5em' }}
      />
      <button onClick={handleAdd}>Add</button>
    </div>
  );
};
